import strings from 'strings';
import {
  OtherFileCategoryId,
  PortfolioFileCategoryId,
  ResumeFileCategoryId
} from 'UI/components/organisms/sendouts/utils';

const { attachments: STRINGS } = strings.sendoutsV2.form.sections;

export const PROCESS_TYPE = {
  Sendout: {
    title: 'Sendout',
    id: 1
  },
  Sendover: {
    title: 'Sendover',
    id: 2
  }
};

export const ATTACHMENTS_CATEGORIES = {
  resume: {
    id: ResumeFileCategoryId,
    title: STRINGS.categories.resume,
    required: false,
    multiple: true
  },
  portfolio: {
    id: PortfolioFileCategoryId,
    title: STRINGS.categories.portfolio,
    required: false,
    multiple: true
  },
  other: {
    id: OtherFileCategoryId,
    title: STRINGS.categories.otherFiles,
    required: false,
    multiple: true
  }
};
